module.exports = __webpack_public_path__ + "static/media/featured_img_two.d70e9ad8.jpg";